import React from "react";
import { useNavigate } from "react-router-dom";
import { SadFaceIcon } from "../../icons";
import "./NotFoundPage.scss";

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="nfp-root">
      <div className="nfp-card">
        <div className="nfp-icon">
          <SadFaceIcon size={56} />
        </div>

        <h1 className="nfp-code">404</h1>
        <h2 className="nfp-title">Page Not Found</h2>
        <p className="nfp-message">The page you're looking for doesn't exist or has been moved.</p>

        <div className="nfp-actions">
          <button className="nfp-btn nfp-btn--primary" onClick={() => navigate("/dashboard")}>
            Go to Dashboard
          </button>
          <button className="nfp-btn nfp-btn--secondary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
